import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoggedInUser } from "../../store/redux/login";

function ProtectedRoutes() {
  const userInfo = useSelector((state) => state.login.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const authUser = sessionStorage.getItem("user");
    if (authUser && !userInfo) {
      const userData = JSON.parse(authUser);
      // Update Redux store here if needed
      dispatch(setLoggedInUser(userData));
    }
  }, [dispatch, userInfo]);

  if (userInfo) {
    return <Outlet />;
  } else {
    return <Navigate to="/" />;
  }
}

export default ProtectedRoutes;
